<mat-sidenav-container class="shell">
  <!-- SIDENAV (mobil) -->
  <mat-sidenav
    #drawer
    mode="over"
    position="end"
    [autoFocus]="false"
    [hasBackdrop]="true"
    [fixedInViewport]="true"
    class="drawer"
    role="navigation">

    <div class="drawer-head">
      <h2>Meniu</h2>
      <button mat-icon-button aria-label="Închide meniul" (click)="drawer.close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-nav-list (click)="closeIfMobile()">
      @for (l of navLinks; track l) {
        @if (l.children?.length) {
          <!-- Parent link -->
          <a mat-list-item
             [routerLink]="l.path"
             routerLinkActive="active"
             [routerLinkActiveOptions]="{ exact: !!l.exact }">
            {{ l.label }}
          </a>
          <!-- Children indented -->
          @for (child of l.children!; track child) {
            <a mat-list-item class="drawer-child"
               [routerLink]="child.path"
               routerLinkActive="active">
              {{ child.label }}
            </a>
          }
        } @else {
          <a mat-list-item
             [routerLink]="l.path"
             routerLinkActive="active"
             [routerLinkActiveOptions]="{ exact: !!l.exact }">
            {{ l.label }}
          </a>
        }
      }
      @if (actionLabel) {
        @if (actionIcon) {
          <button mat-list-item class="drawer-action drawer-icon"
                  type="button"
                  [attr.aria-label]="actionLabel"
                  [attr.title]="actionLabel"
                  (click)="actionClick.emit(); closeIfMobile()">
            <mat-icon>{{ actionIcon }}</mat-icon>
          </button>
        } @else {
          <button mat-list-item class="drawer-action" type="button" (click)="actionClick.emit(); closeIfMobile()">
            {{ actionLabel }}
          </button>
        }
      }
      @if (user$ | async) {
        @if (showPlatformShortcut) {
          <a mat-list-item class="drawer-platform"
             routerLink="/platform"
             routerLinkActive="active"
             [routerLinkActiveOptions]="{ exact: true }">
            Platforma
          </a>
        }
        @if (showHeaderLogout) {
          <button mat-list-item class="drawer-user drawer-logout"
                  type="button"
                  aria-label="Deconectare"
                  title="Deconectare"
                  (click)="logoutFromHeader(); closeIfMobile()">
            <mat-icon>logout</mat-icon>
          </button>
        }
      } @else {
        <a mat-list-item class="drawer-user"
           routerLink="/platform/login"
           aria-label="Autentificare">
          <mat-icon>person</mat-icon>
          <span>Autentificare</span>
        </a>
      }
    </mat-nav-list>
  </mat-sidenav>

  <!-- TOOLBAR -->
  <mat-toolbar class="cj-toolbar" [class.hidden]="hidden" [class.scrolled]="scrolled" role="navigation">
    <div class="toolbar-left">
      <img src="assets/img/logo-v2-eu-gov.webp" alt="Finanțat de Uniunea Europeană și Guvernul României" class="logo" width="2352" height="400" [routerLink]="'/'" />
    </div>

    <!-- NAV (desktop) -->
    <nav class="nav cj-baloo">
      @for (l of navLinks; track l) {
        @if (l.children?.length) {
          <button mat-button
                  [matMenuTriggerFor]="dropMenu"
                  [class.active]="isChildActive(l)"
                  [class.nav-highlight]="l.highlight"
                  class="nav-dropdown-trigger">
            {{ l.label }}
            <mat-icon class="chevron">expand_more</mat-icon>
          </button>
          <mat-menu #dropMenu="matMenu" class="cj-nav-menu">
            <a mat-menu-item
               [routerLink]="l.path"
               routerLinkActive="active"
               [routerLinkActiveOptions]="{ exact: !!l.exact }">
              {{ l.label }}
            </a>
            @for (child of l.children!; track child) {
              <a mat-menu-item
                 [routerLink]="child.path"
                 routerLinkActive="active">
                {{ child.label }}
              </a>
            }
          </mat-menu>
        } @else {
          <a mat-button
             [routerLink]="l.path"
             routerLinkActive="active"
             [routerLinkActiveOptions]="{ exact: !!l.exact }"
             [class.nav-highlight]="l.highlight">
            {{ l.label }}
          </a>
        }
      }
      @if (actionLabel) {
        @if (actionIcon) {
          <button mat-icon-button type="button" class="nav-icon nav-action"
                  [attr.aria-label]="actionLabel"
                  [attr.title]="actionLabel"
                  (click)="actionClick.emit()">
            <mat-icon>{{ actionIcon }}</mat-icon>
          </button>
        } @else {
          <button mat-button type="button" class="nav-action" (click)="actionClick.emit()">
            {{ actionLabel }}
          </button>
        }
      }
      @if (user$ | async) {
        @if (showPlatformShortcut) {
          <a mat-button
             routerLink="/platform"
             routerLinkActive="active"
             [routerLinkActiveOptions]="{ exact: true }">
            Platforma
          </a>
        }
        @if (showHeaderLogout) {
          <button mat-icon-button class="nav-icon nav-logout"
                  type="button"
                  aria-label="Deconectare"
                  title="Deconectare"
                  (click)="logoutFromHeader()">
            <mat-icon>logout</mat-icon>
          </button>
        }
      } @else {
        <a mat-icon-button class="nav-icon"
           routerLink="/platform/login"
           routerLinkActive="active"
           aria-label="Autentificare"
           title="Autentificare">
          <mat-icon>person</mat-icon>
        </a>
      }
    </nav>

    <!-- HAMBURGER (mobil) -->
    <button class="burger" mat-icon-button aria-label="Deschide meniul" (click)="drawer.open()">
      <mat-icon>menu</mat-icon>
    </button>
  </mat-toolbar>
</mat-sidenav-container>
